(function (angular) {
    'use strict';

    angular.module('ui.order.newOrderRouteContainer', [])

        .config(function ($stateProvider) {

            $stateProvider.state('client.new-order', {
                url: '/new', // ?protoOrderId&protoOrderItemId
                templateUrl: 'app/ui/order/newOrderView/newOrderRouteContainer/newOrderRouteContainer.html',
                data: {pageTitle: 'OrderManager: New Order'},
                controller: 'NewOrderRouteContainerController',
                controllerAs: 'NewOrderRouteContainerController'
            });

        })

        .controller('NewOrderRouteContainerController', function () {
            // $scope.protoOrderId = $stateParams.protoOrderId;
            // $scope.protoOrderItemId = $stateParams.protoOrderItemId;
        })
    ;
})(window.angular);
